import { Navigate } from 'react-router-dom';
import { useHotelPermissions, HotelPermission } from '../../hooks/useHotelPermissions';

interface HotelProtectedRouteProps {
  children: React.ReactNode;
  permission?: HotelPermission;
  permissions?: HotelPermission[];
  requireAll?: boolean;
  fallbackPath?: string;
}

/**
 * Composant pour protéger les routes du portail hôtel selon les permissions
 */
export default function HotelProtectedRoute({
  children,
  permission,
  permissions,
  requireAll = false,
  fallbackPath = '/access-denied'
}: HotelProtectedRouteProps) {
  const { hasPermission, hasAnyPermission, hasAllPermissions } = useHotelPermissions();

  // Vérifier la permission unique
  if (permission && !hasPermission(permission)) {
    return <Navigate to={fallbackPath} replace />;
  }

  // Vérifier les permissions multiples
  if (permissions && permissions.length > 0) {
    const hasAccess = requireAll
      ? hasAllPermissions(...permissions)
      : hasAnyPermission(...permissions);

    if (!hasAccess) {
      return <Navigate to={fallbackPath} replace />;
    }
  }

  return <>{children}</>;
}
